import { API_MAX_RESULTS, PAGES } from "@/common/consts";
import {
	calculateRangeForPagination,
	generatePaginationShownWordsText,
	generateShowMoreShownWordsText,
} from "~/pages/Results/helpers";

export default {
	/**
	 * The actions column is always appended, so we only
	 * need to look for 2 fields to know that there are 3 columns.
	 **/
	hasThreeColumns() {
		return this.fields.length === 2;
	},
	isLengthPage() {
		return (
			this.$route.name === PAGES.WORDS_BY_LENGTH_RESULTS ||
			this.$route.name ===
				PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS
		);
	},
	currentPageContent() {
		const content = [...this.tableWords, ...this.tableWordsExtended].map(
			(word, index) => {
				word.highlightedWord = this.highlightWord(word.word, word.mod);
				return {
					word,
					ad: null,
					isVisible: index < this.itemsToShow,
				};
			}
		);
		this.rowAds.forEach((ad) => {
			if (content[ad.position - 1]) {
				content[ad.position - 1].ad = {
					stub: ad.stub,
					type: ad.type,
					showAd: ad.showAd,
					placement: ad.placement || null,
					positionHTL: ad.positionHTL || null,
				};
			}
		});
		return content;
	},
	tableWords() {
		return this.words || [];
	},
	tableTotal() {
		return this.wordsMeta?.total || API_MAX_RESULTS;
	},
	wordCountLabel() {
		if (
			[
				PAGES.WORDS_BY_LENGTH_RESULTS,
				PAGES.WORDLE_RESULTS,
				PAGES.QUORDLE_RESULTS,
				PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS,
			].includes(this.$route.name)
		) {
			return null;
		}

		const noun = this.tableTotal === 1 ? "word" : "words";
		return `${this.tableTotal} ${noun}`;
	},
	paginationString() {
		if (this.buttonMode === null) {
			return "";
		}
		const { start, end } = calculateRangeForPagination(
			this.$route.query.page || 1,
			this.itemsToShow,
			this.tableTotal
		);
		const variables = {
			ShownWords: this.isLengthPage
				? generatePaginationShownWordsText(start, end, this.tableTotal)
				: generateShowMoreShownWordsText(
						this.itemsToShow,
						this.tableTotal
				  ),
			TotalWords: this.tableTotal,
		};
		const dictKey = this.isSmallDevice
			? "ResultTableTextWordsShownMobile"
			: "ResultTableTextWordsShown";
		return this.$t(dictKey, variables);
	},
	tableControllerHeight() {
		return this.isSmallDevice ? 43 : 38;
	},
	headerOffsetTop() {
		if (!this.tableRef) {
			return null;
		}
		const clearanceHeight =
			this.$store.getters["window/headerClearanceHeight"];
		const mobileHeaderHeight =
			this.$store.state.window.searchMobileHeaderHeight;

		return `${
			clearanceHeight +
			mobileHeaderHeight +
			this.tableControllerHeight +
			(this.isSmallDevice ? 75 : 0)
		}px`;
	},
};
